import { render, staticRenderFns } from "./sellerInfo.vue?vue&type=template&id=4d998030&scoped=true"
import script from "./sellerInfo.vue?vue&type=script&lang=js"
export * from "./sellerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d998030",
  null
  
)

export default component.exports